var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('looping-rhombuses-spinner',{attrs:{"animation-duration":2500,"rhombus-size":15,"color":"#ff1d5e"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }